<template>
    <div>
        <page-title title="作品信息">
            <el-descriptions :column="2">
                <el-descriptions-item label="作品名称">{{formOptions.workName}}</el-descriptions-item>
                <el-descriptions-item label="作品类别">{{formOptions.workCategory.category}}</el-descriptions-item>
                <el-descriptions-item label="工作站点">{{formOptions.workPlace.place}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="2">
                <el-descriptions-item label="类别说明">{{formOptions.workCatetoryDescription}}</el-descriptions-item>
            </el-descriptions>
        </page-title>
        <page-title title="著作人权">
            <el-descriptions :column="2">
                <el-descriptions-item label="姓氏或名称">{{formOptions.copyrightOwnerName}}</el-descriptions-item>
                <el-descriptions-item label="类别">{{formOptions.copyrightOwnerType.value}}</el-descriptions-item>
                <el-descriptions-item label="证件类型">{{formOptions.copyrightOwnerCertType.value}}</el-descriptions-item>
                <el-descriptions-item label="证件号码">{{formOptions.copyrightOwnerCertNum}}</el-descriptions-item>
                <el-descriptions-item label="国家">{{formOptions.country}}</el-descriptions-item>
                <el-descriptions-item label="省份">{{formOptions.province}}</el-descriptions-item>
                <el-descriptions-item label="城市">{{formOptions.city}}</el-descriptions-item>
            </el-descriptions>
        </page-title>
        <page-title title="作者信息">
            <el-descriptions :column="2">
                <el-descriptions-item label="姓氏或名称">{{formOptions.author}}</el-descriptions-item>
                <el-descriptions-item label="署名情况">{{formOptions.signatureSituation.value}}</el-descriptions-item>
                <el-descriptions-item label="作品署名">{{formOptions.workSignature}}</el-descriptions-item>
            </el-descriptions>
        </page-title>
        <page-title title="作品基本信息">
            <el-descriptions :column="2">
                <el-descriptions-item label="作品创作性质">{{formOptions.natureOfCreation.value}}</el-descriptions-item>
            </el-descriptions>
        </page-title>
        <page-title title="权利情况说明">
            <el-descriptions :column="2">
                <el-descriptions-item label="权利取得方式">{{formOptions.privAcquireType.value}}</el-descriptions-item>
                <el-descriptions-item label="权利取得说明">{{formOptions.privAcquireTypeDesc}}</el-descriptions-item>
                <el-descriptions-item label="权利归属方式">{{formOptions.priBelongs.value}}</el-descriptions-item>
                <el-descriptions-item label="权利归属说明">{{formOptions.priBelongsDesc}}</el-descriptions-item>
            </el-descriptions>
            <p>
                <span style="display: inline-block;font-size: 14px;margin-right: 10px;color: #606266;">权利拥有情况:</span>
                <span style="display: inline-block;margin-top: 10px;">
                    <el-tag type="info" style="margin-right: 10px;margin-bottom: 10px;" :key="item.id" v-for="item in formOptions.priHoldList">
                        {{item.value}}
                    </el-tag>
                </span>
            </p>
            <!-- <el-descriptions :column="2">
                <el-descriptions-item label="权利拥有情况">
                    <el-tag type="info" style="margin-right: 10px;" :key="item.id" v-for="item in formOptions.priHoldList">
                        {{item.value}}
                    </el-tag>
                </el-descriptions-item>
            </el-descriptions> -->
        </page-title>
        <page-title title="申请人信息">
            <el-descriptions :column="2">
                <el-descriptions-item label="申请方式">{{formOptions.applyType.value}}</el-descriptions-item>
                <el-descriptions-item label="姓氏或名称">{{formOptions.applicantName}}</el-descriptions-item>
                <el-descriptions-item label="详细地址">{{formOptions.applicantAddr}}</el-descriptions-item>
                <el-descriptions-item label="联系人">{{formOptions.applicantContacterName}}</el-descriptions-item>
                <el-descriptions-item label="联系人手机">{{formOptions.applicantContactPhone}}</el-descriptions-item>
                <el-descriptions-item label="邮编">{{formOptions.applicantPost}}</el-descriptions-item>
                <el-descriptions-item label="邮箱">{{formOptions.applicantEmail}}</el-descriptions-item>
            </el-descriptions>
        </page-title>
        <page-title title="电子资料下载">
            <el-row v-if="formOptions.yangbenThumbnailUrl">
                <el-link type="primary" @click='downloadFile(formOptions.yangbenThumbnailUrl, "作品登记样本")'>1.作品登记样本</el-link>
            </el-row>
            <el-row v-if="formOptions.chuangyishuomingUrl">
                <el-link type="primary"  @click='downloadFile(formOptions.chuangyishuomingUrl, "作品创意说明")'>2.作品创意说明</el-link>
            </el-row>
            <el-row v-if="formOptions.qulibaozhengshuUrl">
                <el-link type="primary"  @click='downloadFile(formOptions.qulibaozhengshuUrl, "作品自愿登记权利保证书")'>3.作品自愿登记权利保证书</el-link>
            </el-row>
            <el-row v-if="formOptions.shuquanshuUrl">
                <el-link type="primary"   @click='downloadFile(formOptions.shuquanshuUrl, "委托登记授权书")'>4.委托登记授权书</el-link>
            </el-row>
            <el-row v-if="formOptions.hezuozuopinUrl">
                <el-link type="primary"   @click='downloadFile(formOptions.hezuozuopinUrl, "著作权归属证明文件-合作作品")'>5.著作权归属证明文件-合作作品</el-link>
            </el-row>
            <el-row v-if="formOptions.weituozuopinUrl">
                <el-link type="primary"  @click='downloadFile(formOptions.weituozuopinUrl, "著作权归属证明文件-委托作品")'>6.著作权归属证明文件-委托作品</el-link>
            </el-row>
            <el-row v-if="formOptions.farenzuopinUrl">
                <el-link type="primary"  @click='downloadFile(formOptions.farenzuopinUrl, "著作权归属证明文件-法人作品")'>7.著作权归属证明文件-法人作品</el-link>
            </el-row>
            <el-row v-if="formOptions.zhiwuzuopinUrl">
                <el-link type="primary" @click='downloadFile(formOptions.zhiwuzuopinUrl, "著作权归属证明文件-职务作品")'>8.著作权归属证明文件-职务作品</el-link>
            </el-row>
            <el-row v-if="formOptions.shengfenzhengmingUrl">
                <el-link type="primary" @click='downloadFile(formOptions.shengfenzhengmingUrl, "身份证明文件")'>9.身份证明文件</el-link>
            </el-row>
            <el-row v-if="formOptions.qitaUrl">
                <el-link type="primary" @click='downloadFile(formOptions.qitaUrl, "其他")'>10.其他</el-link>
            </el-row>
        </page-title>
        <page-title title="处理意见">
            <el-input :disabled="['ERROR', 'SUCCESS', 'canceled'].includes(formOptions.status)"
            type="textarea" row="5" v-model="feedback" show-word-limit :maxlength="500"></el-input>
            <div style="margin-top:10px;">
                <el-button v-if="!['ERROR', 'SUCCESS', 'canceled'].includes(formOptions.status)" @click="updateFun('ERROR')" type="primary">审核不通过</el-button>
                <el-button v-if="!statusList.includes(formOptions.status)" @click="updateFun('AGREE')" type="primary">已接受资料</el-button>
                <el-button v-if="!['ERROR', 'SUCCESS', 'canceled'].includes(formOptions.status)" @click="updateFun('SUCCESS')" type="primary">申请成功</el-button>
                <el-button @click="$router.go(-1)">关闭</el-button>
            </div>
        </page-title>
    </div>
</template>

<script>
  import {ptbqdjUpdate} from '@/api/req';
  import download from "downloadjs";
  import PageTitle from '@/components/pageTitle.vue';
    export default {
        created(){
            this.formOptions = this.$route.query.detail ? JSON.parse(this.$route.query.detail) : {};
            this.formOptions.feedback = this.formOptions.feedBack === 'undefined' || !this.formOptions.feedBack
            ?  '' : this.formOptions.feedBack;
            console.log('this.formOptions.feedback', {...this.formOptions})
            this.feedback = this.formOptions.feedback;
        },
        components: {
            PageTitle,
        },
        methods: {
            downloadFile(fileAddress, fileName){
                const filePathArr = fileAddress.split('/');
                const tempFileNameArr = filePathArr[filePathArr.length - 1].split('.');
                const suffix = tempFileNameArr[tempFileNameArr.length - 1]
                const fileNameAndPrifie = fileName + '.' +suffix;
                const download = (blob, fileName) => {
                    const a = document.createElement('a');
                    a.download = window.decodeURIComponent(fileName);
                    a.href = window.URL.createObjectURL(blob);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
                var ajax = new XMLHttpRequest();
                ajax.open( "GET", fileAddress, true);
                ajax.responseType = 'blob';
                ajax.onload= function(e){
                    download(e.target.response, fileNameAndPrifie);
                };
                setTimeout(function(){ ajax.send();}, 0);
            },
            updateFun(status){
                this.$ajax.post(`${ptbqdjUpdate}?id=${this.formOptions.id}&status=${status}&feedback=${this.feedback}`, {
                    status,
                    feedback: this.feedback,
                    id: this.formOptions.id
                }).then(res=>{
                    this.$message({
                        showClose:true,
                        message:'更新成功',
                        type:'success',
                        center:true,
                        duration:3000
                    })
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 500);
                })
            },
        },
        data(){
            return {
                statusList: ['ERROR', 'AGREE', 'SUCCESS', 'canceled'],
                formOptions: {

                },
                feedback: ''
            }
        },
    }
</script>

